import { render, staticRenderFns } from "./PalierCustomer.vue?vue&type=template&id=67965b7a&"
import script from "./PalierCustomer.vue?vue&type=script&lang=js&"
export * from "./PalierCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports